import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const GlimpseOfTheDay = () => {
     useEffect(() => {
        document.title = 'Glimpse Of The Day-  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li>  Events  </li> 
     <li>Glimpse Of The Day </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Glimpse Of The Day  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
       <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/comingsoon.jpg" className="img-fluid mx-auto d-block"/> 
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default GlimpseOfTheDay
